import { render, staticRenderFns } from "./CustomData.vue?vue&type=template&id=58ba1201&lang=pug"
import script from "./CustomData.vue?vue&type=script&lang=js"
export * from "./CustomData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports